module.exports = __webpack_public_path__ + "assets/img/firstLIndex.70f0b30c.png";